export const analyticsId = {
  BROKER_STOCKS_CONTRACT_STEP_1_VIEW: 'BROKER_STOCKS_CONTRACT_STEP_1_VIEW',
  BROKER_STOCKS_CONTRACT_STEP_2_VIEW: 'BROKER_STOCKS_CONTRACT_STEP_2_VIEW',
  BROKER_STOCKS_CONTRACT_STEP_3_VIEW: 'BROKER_STOCKS_CONTRACT_STEP_3_VIEW',
  BROKER_STOCKS_CONTRACT_STEP_1_SUCCESS: 'BROKER_STOCKS_CONTRACT_STEP_1_SUCCESS',
  BROKER_STOCKS_CONTRACT_STEP_2_SUCCESS: 'BROKER_STOCKS_CONTRACT_STEP_2_SUCCESS',
  BROKER_STOCKS_CONTRACT_STEP_3_SUCCESS: 'BROKER_STOCKS_CONTRACT_STEP_3_SUCCESS',
  BROKER_STOCKS_CONTRACT_ERROR: 'BROKER_STOCKS_CONTRACT_ERROR',
  BROKER_STOCKS_CONTRACT_SUCCESS: 'BROKER_STOCKS_CONTRACT_SUCCESS',
};

const commonFields = () => ({
  sectionFamily: 'wealth',
  sectionCategory: 'products',
  sectionName: 'portfolio',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'contractingPortfolio',
  productName: 'portfolio',
});

export const catalogue = {
  [analyticsId.BROKER_STOCKS_CONTRACT_STEP_1_VIEW]: () => ({
    ...commonFields(),
    event_name: 'step_product_details',
    pageName: '/contractingPortfolio/step1/productDetails',
    processStep: 'step1',
    processDetail: 'productDetails',
  }),
  [analyticsId.BROKER_STOCKS_CONTRACT_STEP_2_VIEW]: () => ({
    ...commonFields(),
    event_name: 'step_bank_details',
    pageName: '/contractingPortfolio/step2/bankDetails',
    processStep: 'step2',
    processDetail: 'bankDetails',
  }),
  [analyticsId.BROKER_STOCKS_CONTRACT_STEP_3_VIEW]: () => ({
    ...commonFields(),
    event_name: 'step_contract_details',
    pageName: '/contractingPortfolio/step3/contractDetails',
    processStep: 'step3',
    processDetail: 'contractDetails',
  }),
  [analyticsId.BROKER_STOCKS_CONTRACT_STEP_1_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'productDetails',
    data: 'next',
  }),
  [analyticsId.BROKER_STOCKS_CONTRACT_STEP_2_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'bankDetails',
    data: 'next',
  }),
  [analyticsId.BROKER_STOCKS_CONTRACT_STEP_3_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'otp',
    data: 'next',
  }),
  [analyticsId.BROKER_STOCKS_CONTRACT_ERROR]: ({ errorMessage }) => ({
    ...commonFields(),
    event_name: 'step_error',
    pageName: '/contractingPortfolio/error/genericError',
    processStep: 'error',
    processDetail: 'genericError',
    errorCategory: 'genericError',
    errorDescription: errorMessage,
  }),
  [analyticsId.BROKER_STOCKS_CONTRACT_SUCCESS]: () => ({
    ...commonFields(),
    event_name: 'step_success',
    pageName: '/contractingPortfolio/success',
    processStep: 'success',
  }),
};
